module.exports = __webpack_public_path__ + "static/media/14.1eb8d031.png";